<div class="grid-4col gap pt-3">
    <app-text-input class="fr-2" id="name" [form]="form" [prefix]="prefix"></app-text-input>
<!--    <app-select-input class="fr-2" id="billCode" [form]="form" [prefix]="prefix"-->
<!--        [staticOptions]="[]"></app-select-input>-->
    <app-date-input id="validFrom" [form]="form" [prefix]="prefix"></app-date-input>
    <app-date-input id="validTo" [form]="form" [prefix]="prefix"></app-date-input>

    <app-text-area-input class="fr-2 fh-5" id="description" [form]="form"
        [label]="prefix + 'fields.description'"></app-text-area-input>

    <app-select-input class="fr-2" id="mpsvRegion" [form]="form" [prefix]="prefix"
        [staticOptions]="socialServiceMpsvRegionEnumOptions"></app-select-input>
</div>
